import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  input
} from "@angular/core";

import { MatProgressSpinner } from "@angular/material/progress-spinner";

@Component({
  selector: "app-page-container",
  templateUrl: "./page-container.component.html",
  imports: [MatProgressSpinner],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageContainerComponent implements OnInit {
  title = input<string | undefined>();
  subtitle = input<string | undefined>();
  isLoading = input<boolean>(false);

  constructor() {}

  ngOnInit(): void {}
}
